import useLocalStorageState from "use-local-storage-state";
import { ETransactionType } from "../helpers/constants";
import useCurrentUser from "./useCurrentUser";

const ACCOUNT_KEY = "account";

const DEFAULTS: {
  lastAccount: string;
  lastPaymentMethod: string;
  lastYear: string;
  lastTransactionType: ETransactionType;
  resultsPerPage: number;
  quickFilterText: string;
  page: number;
} = {
  lastAccount: "",
  lastPaymentMethod: "",
  lastYear: "",
  lastTransactionType: ETransactionType.EXPENSE,
  resultsPerPage: 10,
  quickFilterText: "",
  page: 0,
};

export default function useAccountLocalStorage(key: string = "default") {
  const { userInfo } = useCurrentUser();

  const [lastAccountPreferences, setLastAccountPreferences] =
    useLocalStorageState(`${userInfo?._id}-${ACCOUNT_KEY}-${key}`, {
      defaultValue: DEFAULTS,
    });

  return {
    accountLocalStoragePreferences: lastAccountPreferences,
    updateAccountLocalStorage: (newState: Partial<typeof DEFAULTS>) => {
      setLastAccountPreferences((prev: any) => ({ ...prev, ...newState }));
    },
  };
}
